import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        bodyOverflow: false,
        isSelf:false,
        TA:'他'
    },
    mutations: {
        overFlowHidden(state) {
            state.bodyOverflow = true
        },
        overFlowAuto(state) {
            state.bodyOverflow = false
        },
        changeIsSelf(state){
            state.isSelf = true
        },
        changeTA(state){
            state.TA = '她'
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js